import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface EditorState {
  rawJson: string;
  hasUserEdited: boolean;
}

const initialState: EditorState = {
  rawJson: ``,
  hasUserEdited: false
};

const editorSlice = createSlice({
  name: "editor",
  initialState,
  reducers: {
    setRawJson: (state, action: PayloadAction<string>) => {
      state.rawJson = action.payload;
      state.hasUserEdited = true;
    },
    clearRawJson: (state) => {
      state.rawJson = ``;
      state.hasUserEdited = false;
    },
  },
});

export const { setRawJson, clearRawJson } = editorSlice.actions;
export default editorSlice.reducer;
